const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7×24小时全天候热点监控，重大瓜料第一时间推送，让你永远快人一步掌握最新动态。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '支持安卓下载与苹果版客户端，提供51吃瓜app、51吃瓜轻量版多种版本，不同设备畅快吃瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '所有安装包经过严格安全检测，数据传输全程加密，用户隐私得到充分保护。',
  },
  {
    icon: 'ri-global-line',
    title: '全网聚合',
    desc: '覆盖100+信息源，一站式浏览全网热门八卦，无需在多个平台间反复切换。',
  },
  {
    icon: 'ri-thumb-up-line',
    title: '智能推荐',
    desc: '基于你的阅读偏好智能推送感兴趣的内容，越用越懂你的吃瓜口味。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择51吃瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            五大优势，打造极致的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/60 text-center transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-lg bg-primary-50 flex items-center justify-center">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}